import {useQuery} from "@tanstack/react-query";
import useConfigureAxios from "@FRAMEWORK/utils/useConfigureAxios";
import {EventTourDetailBFF} from "@/pages/api/bff/types/eventTourDetail";

/**
 * @description 행사관광정보 BFF
 * @param evCd
 * @returns
 */
const useEventTourDetail = (evCd: string) =>
	useQuery<EventTourDetailBFF>({
		queryKey: ["useEventTourDetailBFF", evCd],
		queryFn: () => useConfigureAxios.get(`/bff/eventTourDetail`, {params: {evCd}}).then(r => r.data),
		placeholderData: {
			accommodation: {show: false, data: [], title: ""},
			tourSpot: {show: false, data: [], title: ""},
			entertainment: {show: false, data: [], title: ""},
			food: {show: false, data: [], title: ""},
			optionalTour: {show: false, data: [], title: ""},
		},
	});

export default useEventTourDetail;
